module.exports = __webpack_public_path__ + "media/images/icons/flash-28ffb6d633dd87065167a6b4a67ddd6f.svg";